import React from "react";
import PropTypes from 'prop-types';
import SelectDataTable from '../form/SelectDataTable';
import HsmOrganizationService from "../../../shared/service/HsmOrganizationService";
import HsmOrganizationColumnForDialog from '../../../shared/component/dataTable/columns/HsmOrganizationColumnForDialog';
import Dialog from "../dialog/Dialog";
import {PAGE_MODE} from "../../utils/Constants";
import {TabPanel, TabView} from "primereact/tabview";
import BillingAccountView from "../../../module/asset-management/billing-account/BillingAccountView";
import GeneralUtils from "../../utils/GeneralUtils";
import HsmOrganizationView from "../../../module/account/organization/HsmOrganizationView";
import HsmOrganizationList from "../../../module/account/organization/HsmOrganizationList";

export default class OrganizationGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            value: this.props.value,
            validate: this.props.validate,
            dataTable: this.props.dataTable,
            label: this.props.label,
            disabled: this.props.disabled,
            addNewButton: this.props.addNewButton,
            name: this.props.name
        };
        this.service = new HsmOrganizationService();
    }

    componentDidMount = () => {
        if(this.state.data && GeneralUtils.checkPrivilege(HsmOrganizationColumnForDialog.name, 'View')) {
            this.refHsmOrganizationView.setPageMode(PAGE_MODE.VIEW);
            this.refBillingAccountView.setPageMode(PAGE_MODE.VIEW);
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            data: this.props.data,
            validate: nextProps.validate,
            value: nextProps.value,
            dataTable: nextProps.dataTable,
            label: nextProps.label,
            disabled: nextProps.disabled,
            addNewButton: nextProps.addNewButton,
            name: nextProps.name
        });
    }

    render() {
        let validate = this.state.validate;
        if (!validate) {
            validate = {
                required: {
                    value: true,
                    errorMessage: "Bu alanın doldurulması zorunludur."
                }
            };
        }

        let dataTable = this.state.dataTable;
        if (!dataTable) {
            dataTable = {
                dataURL : "hsmOrganization/findAll",
                fields: HsmOrganizationColumnForDialog.fields
            };
        }
        let label = this.state.label;
        if (!label) {
            label = "Organizasyon Adı"
        }
        let name = this.state.name;
        if (!name) {
            name = "organizationId"
        }
        let openDetailDialog = (this.state.data && GeneralUtils.checkPrivilege(HsmOrganizationColumnForDialog.name, 'View')) ? this.openDetailDialog : false;
        return (
            <div>
                <SelectDataTable
                    value={this.state.value}
                    validate={validate}
                    dataTable={dataTable}
                    disabled={this.state.disabled}
                    addNewButton={this.state.addNewButton}
                    name={name}
                    translateKey="asset-management.organizationId"
                    label={label}
                    dialogHeader="Organizasyon Listesi"
                    onDataSelect={this.props.onDataSelect}
                    autoRefrestData={false}
                    openDetailDialog={openDetailDialog}
                    createNewOrganization={this.props.createNewOrganization}
                />
                {(this.state.data && GeneralUtils.checkPrivilege(HsmOrganizationColumnForDialog.name, 'View')) && this.getDetailDialog()}
            </div>
        );
    }

    openDetailDialog = () => {
        this.refHsmOrganizationView.setData(Object.assign({}, this.state.data), PAGE_MODE.VIEW);
        this.refBillingAccountView.setDataByOrganizationId(this.state.data.id, PAGE_MODE.VIEW);
        this.setState({displayDialog: true});
    }

    getDetailDialog = () => {
        let result = (
            <Dialog style={{width: '70%'}}
                    visible={this.state.displayDialog}
                    header="Organizasyon ve Fatura Hesabı Bilgileri"
                    onHide={() => this.setState({displayDialog: false})}>
                <TabView activeIndex={this.state.activeIndex}
                         onTabChange={(e) => this.setState({activeIndex: e.index})} renderActiveOnly={false}>
                    <TabPanel
                        header="Organizasyon Bilgileri">
                        <HsmOrganizationView save={this.findAll} ref={(elem) => this.refHsmOrganizationView = elem}
                                             closeDisplayDialog={() => this.setState({displayDialog: false})}/>
                    </TabPanel>

                    <TabPanel header="Fatura Hesabı">
                        <BillingAccountView ref={(elem) => this.refBillingAccountView = elem}/>
                    </TabPanel>
                </TabView>
            </Dialog>
        );
        return result;
    }

}
OrganizationGroup.propTypes = {
    data: PropTypes.object,
    value: PropTypes.string,
    validate: PropTypes.object,
    dataTable: PropTypes.object,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    addNewButton: PropTypes.bool,
    name: PropTypes.string
}